import {Component, ComponentFactoryResolver, DoCheck, Inject, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import {AppConfig} from "./config/app.config";
import {LoaderService} from "./services/loader.service";
import {UserInterface} from "./models/user.interface";
import {SwalComponentService} from "./services/swal-component.service";
import {AppState} from "./states/app.state";
import {Store} from "@ngxs/store";
import {DOCUMENT} from "@angular/common";
import {AppHelper} from "./helpers/app.helper";
import {AppStateInterface} from "./models/app-state.interface";
import { CarteraInterface } from './models/cartera.interface';
import { WalletState } from './states/wallets.state';
import { Subscription } from 'rxjs';
import { ShareTotalWalletService } from './services/share-total-wallet.service';
import { PriceTotalWalletDirective } from './components/directive/price-total-wallet.directive';
import { CarteraColumnFieldComponent } from './components/cartera-column-field/cartera-column-field.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, DoCheck, AfterViewInit {

  cartera: CarteraInterface;

  showTotalWallet: boolean = false;

  appConfig = AppConfig;

  logged = false;

  formType = 'login';

  ready = false;

  requesting = false;

  loading = false;

  user: UserInterface;

  subscription: Subscription;

  @ViewChild(PriceTotalWalletDirective) priceTotalDynamic: PriceTotalWalletDirective;

  constructor(@Inject(DOCUMENT) private document: Document, private loaderService: LoaderService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private shareTotalWalletService: ShareTotalWalletService,
              private swalService: SwalComponentService, private store: Store) {

    store.select(AppState.darkMode).subscribe((darkMode: boolean) => {

      this.setBodyClass(darkMode);
    });
  }

  ngOnInit(): void {

    this.loaderService.onLoadingChanged.subscribe(status => this.loading = status );

    const appData: any = this.store.selectSnapshot<any>( state => state.appData);
    this.user = JSON.parse(JSON.stringify(appData.profile));

    if (this.user.token && this.user.refreshToken) {

      this.logged = true;
    }

    this.setBodyClass();

    setTimeout(() => {
      this.ready = true;
    }, 600);



  }

  ngAfterViewInit() {

    this.shareTotalWalletService.subscriber$.subscribe( (data:any)  => {
      if(data.wallet){

        this.cartera = data.wallet;
        this.showTotalWallet = data.showNavTotalWallet;
  
            // create the component factory
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CarteraColumnFieldComponent);
        //const componentRef = componentFactory.create(this.priceTotalDynamic.injector);
        const viewContainerRef = this.priceTotalDynamic.viewContainerRef;
        viewContainerRef.clear();
  
        const componentRef = viewContainerRef.createComponent<any>(componentFactory);
        componentRef.instance.id = this.cartera.id;
        componentRef.instance.class = "font-weight";
        componentRef.instance.field = "precioTotal";

      }
    })

  }

  ngDoCheck(): void {

    if (this.swalService.component) {

      this.swalService.component.changeDetectorRef.detectChanges()
    }
  }

  toggleForm() {

    this.formType = ( this.formType === 'login' ? 'register' : 'login' )
  }

  loginSuccess(ev: { status: boolean, user: UserInterface}) {

    if (ev.status) {

      this.user = ev.user;
    }

    this.logged = ev.status;
    this.setBodyClass();
  }

  totalWalletField(){
    this.subscription = this.store.select(WalletState.wallets).subscribe((cs: any[]) => {

      //this.cartera = cs.find(c => c.id === this.id);

    });

  }

  setBodyClass(darkMode?: boolean) {

    if (darkMode == undefined) {

      darkMode = this.store.selectSnapshot<AppStateInterface>(data => data.appData).darkMode;
    }

    const body = this.document.getElementsByTagName('body').item(0);
    AppHelper.RemoveSkinClasses(body);
    this.logged ? body.classList.add(`${ darkMode ? 'dark' : 'cart' }-skin`) : '';
  }

}
